// extracted by mini-css-extract-plugin
module.exports = {"root":"DoubleLesson_root__RE9vF"};